var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketForceplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_530_9523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 14,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.91675H12.25C12.4047 2.91675 12.5531 2.97821 12.6625 3.0876C12.7719 3.197 12.8333 3.34537 12.8333 3.50008V11.0834C12.8333 11.2381 12.7719 11.3865 12.6625 11.4959C12.5531 11.6053 12.4047 11.6667 12.25 11.6667H5.25",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16663 3.50008C1.16663 3.34537 1.22808 3.197 1.33748 3.0876C1.44688 2.97821 1.59525 2.91675 1.74996 2.91675H5.24996V11.6667H1.74996C1.59525 11.6667 1.44688 11.6053 1.33748 11.4959C1.22808 11.3865 1.16663 11.2381 1.16663 11.0834V3.50008Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20825 4.9585V6.12516",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7916 4.66675L7.29163 9.62508",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79167 7.87508C3.79167 7.55292 3.5305 7.29175 3.20833 7.29175C2.88617 7.29175 2.625 7.55292 2.625 7.87508C2.625 8.19725 2.88617 8.45841 3.20833 8.45841C3.5305 8.45841 3.79167 8.19725 3.79167 7.87508Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79167 9.62508C3.79167 9.30292 3.5305 9.04175 3.20833 9.04175C2.88617 9.04175 2.625 9.30292 2.625 9.62508C2.625 9.94725 2.88617 10.2084 3.20833 10.2084C3.5305 10.2084 3.79167 9.94725 3.79167 9.62508Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_530_9523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketForceplateIcon);
export default __webpack_public_path__ + "static/media/ticketForceplateIcon.e6305a22f3dceec8fece352ffd6beba9.svg";
export { ForwardRef as ReactComponent };